// extracted by mini-css-extract-plugin
export default {"TextEditor":"_TextEditor--y6VmI","Small":"_Small--c7rI_","FullWidth":"_FullWidth--whY3y"};